import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';

@JsonObject('model.shortObject')
export class ShortObject extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'name')
    name?: string;

}

